(function(root,factory){const api=factory(root);if(typeof module!=='undefined')module.exports=api;root.JudesProbierCommerce=api;})(typeof globalThis!=='undefined'?globalThis:this,function(root){
'use strict';
function identity(items){return JSON.stringify(items.map(i=>[String(i.variant_id||i.id),Number(i.quantity),Object.entries(i.properties||{}).sort(),String(i.selling_plan||i.selling_plan_allocation?.selling_plan?.id||'')]).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b))));}
function basketKey(cart){return JSON.stringify([cart.currency,cart.total_price,identity(cart.items),cart.discount_codes||[]]);}
function context(){const el=root.document.querySelector('[data-judes-probier-ab]');return {country:el?.dataset.country||root.Shopify.country,currency:root.Shopify.currency.active};}
function quote(items,discountCode,onVerifiedPrice){return root.JudesProbierPricing.quote({...context(),items,discountCode,onVerifiedPrice,fetchFn:root.fetch.bind(root)});}
async function cart(){const response=await root.fetch(root.Shopify.routes.root.replace(/\/?$/,'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Cart unavailable');return response.json();}
function format(value){return new Intl.NumberFormat(root.document.documentElement.lang||'en',{style:'currency',currency:context().currency}).format(value/100);}
function manifest(){
 const marker=root.document.querySelector('[data-judes-probier-ab]');
 if(marker?.dataset.startPricePilot!=='true'||!root.JudesNativeStartPrice)return null;
 const source=root.document.querySelector('[data-probier-start-price-manifest]');
 return root.JudesNativeStartPrice.parse(source?.textContent||'');
}
function seed(items,discountCode,recipeId,catalogPrices){
 const value=manifest();if(!value)return null;
 const marker=root.document.querySelector('[data-judes-probier-ab]');
 const recipes=root.JudesTrialBundleRecipes;
 return root.JudesNativeStartPrice.resolve(value,{
  ...context(),items,discountCode,recipeId,catalogPrices,
  productId:marker?.dataset.probierProductId,
  recipeVersion:recipes?.sourceVersion,
  pricingIdentityVersion:root.JudesProbierPricing?.identityVersion
 });
}
function refreshDisplay(options){return root.JudesNativeStartPrice.refreshDisplay(options);}
const confirmations=new WeakMap();
async function prepare(payload,code,standalone,button){
 const selectionKey=JSON.stringify([identity(payload.items),String(code||'').toLowerCase()]);
 const cached=confirmations.get(button);
 if(cached&&cached.selectionKey===selectionKey&&Date.now()-cached.at<=30000)return cached.promise;
 const promise=(async()=>{
  const before=await cart();
  const whole=before.items.length?await quote(before.items.concat(payload.items),code):standalone;
  return {...standalone,wholeCartPriceMinor:whole.finalPriceMinor,beforeFingerprint:basketKey(before),beforeCart:before,currency:before.currency};
 })();
 confirmations.set(button,{selectionKey,at:Date.now(),promise});
 try{return await promise;}catch(error){if(confirmations.get(button)?.promise===promise)confirmations.delete(button);throw error;}
}
function invalidate(button){confirmations.delete(button);button?.parentNode?.querySelector?.('[data-probier-cart-total]')?.remove();}
return {identity,basketKey,quote,prepare,format,invalidate,seed,refreshDisplay};
});
